import React from "react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatRupiah } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Copy, Users, Wallet } from "lucide-react";

export default function Team() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/referrals/mine").then((r) => setData(r.data));
  }, []);

  const copy = () => {
    navigator.clipboard.writeText(data.referral_code);
    toast.success("Kode disalin");
  };

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-10" data-testid="team-page">
      <div className="label-mono text-zinc-500">// AFFILIATE</div>
      <h1 className="font-display text-4xl md:text-5xl font-black uppercase mt-1">Tim Saya</h1>

      {!data ? (
        <div className="mt-8 font-mono">// LOADING</div>
      ) : (
        <>
          <div className="mt-8 grid md:grid-cols-3 gap-4">
            <div className="border border-black bg-[#FFD600] p-6 shadow-brutal">
              <div className="label-mono">// KODE REFERRAL</div>
              <div className="flex items-center gap-2 mt-2">
                <span className="font-display text-3xl font-black tracking-tight" data-testid="my-referral-code">{data.referral_code}</span>
                <button onClick={copy} className="p-2 border border-black hover:bg-black hover:text-white" data-testid="copy-referral">
                  <Copy className="w-3.5 h-3.5" />
                </button>
              </div>
              <p className="font-mono text-[11px] mt-3 text-black/70">Bagikan kode ini. Kamu dapat <b>10% komisi</b> dari profit setiap order member.</p>
            </div>
            <div className="border border-black bg-white p-6 shadow-brutal">
              <div className="label-mono text-zinc-500">// MEMBERS</div>
              <div className="font-display text-4xl font-black mt-2 flex items-center gap-2"><Users className="w-7 h-7" /> {data.total_members}</div>
              <p className="font-mono text-[11px] mt-3 text-zinc-500">Total member yang kamu ajak</p>
            </div>
            <div className="border border-black bg-black text-white p-6">
              <div className="label-mono text-[#FFD600]">// COMMISSION</div>
              <div className="font-display text-3xl font-black mt-2 flex items-center gap-2"><Wallet className="w-6 h-6" /></div>
              <div className="font-mono text-2xl font-bold mt-1" data-testid="total-commission">{formatRupiah(data.total_commission)}</div>
              <p className="font-mono text-[11px] mt-3 text-zinc-400">Otomatis masuk ke saldo kamu</p>
            </div>
          </div>

          <div className="mt-8 grid lg:grid-cols-2 gap-6">
            <div className="border border-black bg-white">
              <div className="p-4 border-b border-black label-mono">// MEMBER LIST</div>
              {data.members.length === 0 ? (
                <div className="p-8 text-center font-mono text-xs text-zinc-500">// Belum ada member · share kodemu!</div>
              ) : (
                data.members.map((m) => (
                  <div key={m.id} className="p-4 border-b border-zinc-200 flex justify-between" data-testid={`member-${m.id}`}>
                    <div>
                      <div className="font-mono text-xs font-bold">{m.name}</div>
                      <div className="font-mono text-[10px] text-zinc-500">{m.phone}</div>
                    </div>
                    <div className="font-mono text-[10px] text-zinc-500">{new Date(m.created_at).toLocaleDateString("en-US")}</div>
                  </div>
                ))
              )}
            </div>

            <div className="border border-black bg-white">
              <div className="p-4 border-b border-black label-mono">// COMMISSION HISTORY</div>
              {data.commissions.length === 0 ? (
                <div className="p-8 text-center font-mono text-xs text-zinc-500">// Belum ada komisi</div>
              ) : (
                data.commissions.map((c) => (
                  <div key={c.id} className="p-4 border-b border-zinc-200 flex justify-between" data-testid={`commission-${c.id}`}>
                    <div>
                      <div className="font-mono text-xs">From <b>{c.buyer_name}</b></div>
                      <div className="font-mono text-[10px] text-zinc-500">{c.order_no}</div>
                    </div>
                    <div className="text-right">
                      <div className="font-mono text-sm font-bold text-[#00C853]">+{formatRupiah(c.amount)}</div>
                      <div className="font-mono text-[10px] text-zinc-500">{new Date(c.created_at).toLocaleDateString("en-US")}</div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

